import { useState } from "react";
import { useSelector } from "react-redux";
import { Alert, Box, Button, Typography } from "@mui/material";
import { useBlog } from "./Blog.hooks";
import BlogEditor from "./BlogEditor";
import PostCard from "./PostCard";

const Blog = () => {
  const { posts, loading, error, load, unpublishPost } = useBlog();
  const role = useSelector((s) => s.user?.userData?.role) === "admin" ? "admin" : "practitioner";
  const [editing, setEditing] = useState(null); // null = list view; {} = new; post = edit
  const [actionError, setActionError] = useState("");

  // Taking your own post off the blog: it returns to drafts and has to be
  // submitted for review again before it can go live.
  const onUnpublish = async (post) => {
    const queued = post.pendingSubmittedAt
      ? " Your edit waiting for approval will be kept in the draft."
      : "";
    if (!window.confirm(
      `Take "${post.title}" off the blog? It goes back to your drafts and needs a new review to be published again.${queued}`
    )) return;
    try { await unpublishPost(post.id); load(); }
    catch (e) { setActionError(e.response?.data?.message || "Failed to unpublish post."); }
  };

  if (editing !== null) {
    return (
      <BlogEditor
        post={editing.id ? editing : null}
        role={role}
        onSaved={() => load()}
        onBack={() => { setEditing(null); load(); }}
      />
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Typography variant="h5">My Blog Posts</Typography>
        <Button variant="contained" onClick={() => setEditing({})}>+ New Post</Button>
      </Box>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {actionError && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={() => setActionError("")}>{actionError}</Alert>
      )}
      {loading ? <Typography>Loading…</Typography>
        : error ? null
        : posts.length === 0 ? <Typography>No posts yet.</Typography>
        : posts.map((p) => (
            <PostCard key={p.id} post={p}
              actions={
                <>
                  <Button size="small" onClick={() => setEditing(p)}>Edit</Button>
                  {p.status === "published" && (
                    <Button size="small" color="warning" onClick={() => onUnpublish(p)}>Unpublish</Button>
                  )}
                </>
              } />
          ))}
    </Box>
  );
};

export default Blog;
